
export const paymentMethodViews = self => ({

})